/**
 * @module business 
 *  Apis must need auth details to trigger url - AuthApi
 */

import store from '@/store/index';
import Env from '@/env';
const apiVersion = 'api';
import AuthApis from '@/controllers/AuthApis';
import Helpers from '@/helpers';
import ApiHelper from '@/controllers/ApiHelpers';

export default {
  /*
   * fetch all the pricing group
   */
  fetchAll(page = 1, perPage = 10) {
    const location = store.getters['location/selected']
    let url = `${Env.productUrl}/api/pricing-group/list?page=${page}&perPage=${perPage}`;

    return AuthApis.getApi(url, {
      api_token: Env.productApiToken,
      'Authorization': 'Bearer ' + store.getters['auth/userToken'],
    }).then((response) => {
      return response;
    }).catch((err) => {
      ApiHelper.detectStatusAndRedirect(err);
      return err;
    })
  },

  // Create pricing group
  async createPricingGroup(data){
    const url = `${Env.productUrl}/api/pricing-group`;
    return AuthApis.postApi(url, {
      'Authorization': 'Bearer ' + store.getters['auth/userToken'],
      api_token: Env.productApiToken,
    }, data)
    .then(res => res)
    .catch(err => {
      ApiHelper.detectStatusAndRedirect(err);
      return err;
    });
  },

  // Update pricing group
  async updatePricingGroup(pricingGroupId, data){
    const url = `${Env.productUrl}/api/pricing-group/${pricingGroupId}`;
    return AuthApis.putApi(url, {
      'Authorization': 'Bearer ' + store.getters['auth/userToken'],
      api_token: Env.productApiToken,
    }, data)
    .then(res => res)
    .catch(err => {
      ApiHelper.detectStatusAndRedirect(err);
      return err;
    });
  },

  // Delete pricing group
  async deletePricingGroup(pricingGroupId, data){
    const url = `${Env.productUrl}/api/pricing-group/${pricingGroupId}`;
    return AuthApis.deleteApi(url, {
      'Authorization': 'Bearer ' + store.getters['auth/userToken'],
      api_token: Env.productApiToken,
    }, data)
    .then(res => res)
    .catch(err => {
      ApiHelper.detectStatusAndRedirect(err);
      return err;
    });
  },

  async locationList(params = ''){
    const url = `${Env.productUrl}/api/pricing-group/locations/list${params?'?'+params:''}`;
    console.log(url)
    return AuthApis.getApi(url, {
      'Authorization': 'Bearer ' + store.getters['auth/userToken'],
      api_token: Env.productApiToken,
    })
    .then(res => res)
    .catch(err => {
      ApiHelper.detectStatusAndRedirect(err);
      return err;
    });
  },

  async priceWarning(baseLocationId){
    const url = `${Env.productUrl}/api/pricing-group/locations/warnings/${baseLocationId}`;
    return AuthApis.getApi(url, {
      'Authorization': 'Bearer ' + store.getters['auth/userToken'],
      api_token: Env.productApiToken,
    })
    .then(res => res)
    .catch(err => {
      ApiHelper.detectStatusAndRedirect(err);
      return err;
    });
  }
}